export default __webpack_public_path__ + "static/media/control-system.61a21038.svg";